import { Shark, Utils, View } from "shark-mvc";

import CustomTagsCategory from "../../models/CustomTagsCategory";

import templateContent from "./custom-tags.html";

import customTagsCategoryManager from "../../controllers/customTagsCategoryManager";
import mainNavComponent from "../../components/mainNav/mainNavComponent";
import waitBoxComponent from "../../components/waitBox/waitBoxComponent";

class CustomTagsView extends View {
	route = "custom-tags";

	constructor () {
		super("customTagsView");
		this.setTemplate(templateContent);
	}

	async addCustomTagCategory () {
		const { newCustomTagsCategory } = Shark.get();

		if (newCustomTagsCategory) {
			const saveResult = await customTagsCategoryManager.save(newCustomTagsCategory);
			console.log({saveResult});
			
			Shark.set({
				newCustomTagsCategory: new CustomTagsCategory({
					status: 1,
				}),
			});
			this.refreshList();
		}
	}

	addCustomTagCategoryBtn_clickHandler () {
		this.addCustomTagCategory();
	}

	beforeLoad () {
		window.scrollTo(0, 0);
		this.refreshList();

		Shark.set({
			newCustomTagsCategory: new CustomTagsCategory({
				status: 1,
			}),
		});
	}

	init () {
		this.addComponents([mainNavComponent, waitBoxComponent]);

		Shark.set({
			customTagsCategoryList: Shark.$store.customTagsCategoryList || [],
		});
	}

	refreshList () {
		const sorting = {
			name: "ASC",
		};
		const range = {
			first: 0,
			length: 50,
		};

		customTagsCategoryManager.getList({sorting, range})
		.then(getListResponse => {
			if (getListResponse.data) {
				const customTagsCategoryList = Shark.getInstanceList(CustomTagsCategory, getListResponse.data);
				
				customTagsCategoryList.forEach((item, index) => item.__index = index);
				
				Shark.set({
					customTagsCategoryList,
				});
				// Shark.render();
			}
		});
	}

}

const customTagsView = new CustomTagsView();

Shark.registerView(customTagsView);

export default customTagsView;
